<template>
  <div v-if="isLoading">
    <base-spinner></base-spinner>
  </div>
  <div class="table" v-else>
    <div class="table-header">
      <p>Tin tức thường xuyên</p>

      <div>
        <input v-model="filterTerm" placeholder="Tiêu đề" @keyup.enter="sendFilterTerm"/>
        <button style="background-color: #0298cf; border-radius: 0px; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 40px; margin-right: 15px"
          @click.prevent="sendFilterTerm"><i class="fa-solid fa-magnifying-glass"></i></button>

        <button @click="addClick" class="add-new" v-if="$checkPermission('create_regularNews')">+ Thêm mới</button>
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>Tiêu đề</th>
            <th>Hình ảnh</th>
            <th>Sơ lược</th>
            <th>Đường đẫn</th>
            <th>Ngày tạo</th>
            <th>Trạng thái</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in getNews" :key="i">
            <td>
              <div class="overflow-td">
                {{ ctt.title }}
              </div>
            </td>
            <td><img :src="imageSrc(ctt.img)"></td>
            <td>
              <div class="overflow-td">
                {{ ctt.summary }}
              </div>
            </td>
            <td>
              <div class="overflow-td">
                {{ ctt.url }}
              </div>
            </td>
            <td>{{ formatDate(ctt.createdAt) }}</td>
            <td :class="{'publish-text': !ctt.hidden, 'draft-text': ctt.hidden}">
              {{ showStatus(ctt.hidden) }}
            </td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="togglePreview(ctt.description)"><i class="fa-solid fa-eye"></i></button>
                <button v-if="$checkPermission('approve_article')" @click="adjustStatus(ctt.id)" :style="{ backgroundColor: ctt.hidden ? '#4CDA4C' : '#E2BF31' }">
                  <i v-if="ctt.hidden === false" class="fa-solid fa-arrow-down"></i>
                  <i v-else class="fa-solid fa-arrow-up"></i>
                </button>
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_regularNews')"><i class="fa-solid fa-pen-to-square"></i></button>
                <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_regularNews')"><i class="fa-solid fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; cursor: default; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>
  </div>

  <!-- modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal" size="large" @vnTab="vnTab" @enTab="enTab" :hasLang="true">
    <div v-show="smallLoading" style="min-height: 615px;">
      <base-spinner></base-spinner>
    </div>
    <div v-show="!smallLoading">
      <div class="site-box">
        <div class="first-site">
          <div class="data-display" style="margin-bottom: 10px;">
            <div class="box"> <p>Tiêu đề<span style="color: red;">*</span></p></div>
            <input type="text" v-model="title"/>
          </div>
          <div class="data-display">
            <div class="box"> <p>Ngày hiển thị</p> </div>
            <input type="text" id="date-input" placeholder="dd/mm/yyyy" v-model="dateInputValue" @blur="validateDateInput">
            <input type="date" v-model="date" @keydown.prevent @input="shareDateValue"/>
          </div>
          <!-- <div class="data-display">
            <div class="box"> <p>Lang</p> </div>
             <select v-model="lang">
                <option value="vn">vn</option>
                <option value="en">en</option>
              </select>
          </div> -->
          <div class="data-display" style="margin-bottom: 30px;">
            <div class="box"> <p>Trạng thái</p> </div>
             <select :class="{'publish-text': !hidden, 'draft-text': hidden}" style="background-color: #e2e1e1;" disabled v-model="hidden">
                <option class="draft-text" :value="true">Nháp</option>
                <option class="publish-text" :value="false">Chính thức</option>
              </select>
          </div>
        </div>
        <div class="second-site">
          <div>
            <div v-if="isPreview">
              <img v-if="img" :src="img" style="width: 190px; height: 140px; object-fit: scale-down; background: #efefef;" />
            </div>
            <div v-else>
              <img v-if="img" :src="imageSrc(img)" style="width: 190px; height: 140px; object-fit: scale-down; background: #efefef;" />
            </div>
            <input type="file" @change="previewImage" ref="fileInput" style="margin-top: 5px;">
          </div>
        </div>
      </div>
      <div class="outsite">
        <div class="data-display">
          <p>Sơ lược</p>
          <textarea v-model="summary"></textarea>
        </div>
        <div class="data-display">
          <div class="box" style="margin-bottom: 5px;"> <p>Chi tiết</p> </div>
          <QuillEditor v-model:content="description" :contentType="'html'" toolbar="full" />
        </div>
      </div>
      <div class="btn-container">
        <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id === 0" @click="createClick()">
          <p class="btn-text">Tạo</p>
        </button>
        <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id !== 0" @click="updateClick()">
          <p class="btn-text">Cập nhật</p>
        </button>
      </div>
    </div>
  </base-modal>

  <preview-modal :modalActive="modalPreview" @close="togglePreview" size="large">
    <div class="detail">
      <p class="title">Tin tức</p>
      <div class="date-container">
        <div class="img-container">
          <img src="../../../assets/clock-icon.svg" id="icon">
        </div>
        <p class="date">01/01/2024</p>
      </div>
      <div v-html="$sanitize(description)" class="ql-editor"></div>
    </div>
  </preview-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)" :requestLoading="requestLoading"
    @delete="deleteClick(selectedId)"></alert-modal>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  components: {
    QuillEditor
  },
  data () {
    return {
      pageSize: 6,
      currentPage: 1,
      modalActive: false,
      modalAlert: false,
      modalPreview: false,
      modalTitle: '',
      fileUpload: '',
      isPreview: false,
      filterTerm: '',
      appliedTerm: '',
      isValid: true,
      selectedId: 0,
      propertiesToCheck: ['title'],
      propertiesToBackup: ['id', 'title', 'summary', 'description', 'menuId'],
      vnData: {},
      enData: {},
      cacheBuster: Date.now(),
      isUpdated: false,
      tempImage: '',
      hasCreatedData: false,
      changeLang: false,
      checkEn: false,
      loadEditData: false,
      originalUrl: '',
      msg: '',
      totalPages: 1,
      isLoading: false,
      requestLoading: false,
      smallLoading: false,
      // data
      id: 0,
      vnId: 0,
      enId: 0,
      title: '',
      summary: '',
      vnSummary: '',
      enSummary: '',
      img: '',
      description: '',
      hidden: true,
      url: '',
      menuId: 0,
      lang: 'vn',
      createdAt: '',
      author: '',
      updatedAt: '',
      date: '',
      dateInputValue: ''
    }
  },
  computed: {
    getNews () {
      return this.$store.getters['news/getBackendNewsData']
    }

  },
  watch: {
    lang (newLang) {
      if (newLang === 'en') {
        this.menuId = 9
      } else {
        this.menuId = 2
      }
    },
    date (newDate) {
      this.shareDateValue()
    }
  },
  methods: {
    validateDateInput () {
      if (!this.dateInputValue) {
        this.date = ''
        return
      }
      const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(19[7-9][0-9]|20[0-2][0-9])$/
      if (!regex.test(this.dateInputValue)) {
        this.$showError('Ngày hiển thị sai định dạng')
        this.date = ''
        this.dateInputValue = ''
        return
      }

      const [day, month, year] = this.dateInputValue.split('/').map(Number)
      this.dateInputValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`

      this.date = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    },
    shareDateValue () {
      if (!this.date) {
        this.dateInputValue = ''
        return
      }
      const [year, month, day] = this.date.split('-').map(Number)
      this.dateInputValue = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`
    },
    sendFilterTerm () {
      this.currentPage = 1
      this.appliedTerm = this.filterTerm
      this.getNewsData()
    },
    imageSrc (src) {
      return `${src}?t=${this.cacheBuster}`
    },
    previewImage (event) {
      this.fileUpload = event.target.files[0]
      this.isPreview = true
      if (this.fileUpload) {
        this.img = URL.createObjectURL(this.fileUpload)
      }
    },
    getCurrentDate () {
      const date = new Date()
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return `${year}-${month}-${day}`
    },
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
        this.getNewsData()
      }
    },
    toggleModal () {
      this.modalActive = !this.modalActive
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    togglePreview (dcpt) {
      this.description = this.$sanitize(dcpt)
      this.modalPreview = !this.modalPreview
    },
    vnTab () {
      if (this.hasCreatedData || this.loadEditData) {
        if (this.changeLang) {
          this.enData = this.propertiesToBackup.reduce((acc, prop) => {
            acc[prop] = this[prop]
            return acc
          }, {})
          Object.assign(this, this.vnData)
          this.changeLang = false
        }
        this.lang = 'vn'
      }
      // else {
      //   const data = this.$store.getters['news/vnBackendNewsTab'](this.originalUrl)
      //   this.id = data.id
      //   this.title = data.title
      //   if (this.url === this.originalUrl) this.url = data.url === '' ? this.url : data.url
      //   this.lang = 'vn'
      //   console.log(this.url)
      //   console.log(this.originalUrl)
      // }
    },
    async enTab () {
      this.checkEn = true
      if (this.hasCreatedData || this.loadEditData) {
        if (!this.changeLang) {
          this.vnData = this.propertiesToBackup.reduce((acc, prop) => {
            acc[prop] = this[prop]
            return acc
          }, {})
          Object.assign(this, this.enData)
          this.changeLang = true
        }
        this.lang = 'en'
      } else {
        this.smallLoading = true
        const data = await this.$store.dispatch('news/getEnNewsAdminData', { url: this.originalUrl })
        this.smallLoading = false
        // const data = this.$store.getters['news/enBackendNewsTab'](this.originalUrl)
        this.vnData = this.propertiesToBackup.reduce((acc, prop) => {
          acc[prop] = this[prop]
          return acc
        }, {})
        this.id = data.id
        this.title = data.title
        this.summary = data.summary
        this.description = this.$sanitize(data.description)
        this.menuId = data.menuId
        if (this.url === this.originalUrl) this.url = data.url === '' ? this.url : data.url
        this.lang = 'en'
        this.loadEditData = true
      }
    },
    showStatus (boolean) {
      if (boolean === true) {
        return 'Nháp'
      } else {
        return 'Chính thức'
      }
    },
    formatDate (dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('en-GB')
    },
    generateUrl (name) {
      return name
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/-+/g, '-')
        .toLowerCase()
        .replace(/^-|-$/g, '')
    },
    validateVariable () {
      this.isValid = true
      if (this.lang === 'vn') {
        this.vnData = this.propertiesToBackup.reduce((acc, prop) => {
          acc[prop] = this[prop]
          return acc
        }, {})
      } else {
        this.enData = this.propertiesToBackup.reduce((acc, prop) => {
          acc[prop] = this[prop]
          return acc
        }, {})
      }

      if (!this.checkEn) {
        this.isValid = false
        this.msg = 'Vui lòng kiểm tra dữ liệu phiên bản tiếng Anh một lần trước khi tiếp tục'
      } else {
        if (this.fileUpload === '' && !this.isUpdated) {
          this.isValid = false
          this.msg = 'Hãy chọn hình ảnh'
        }
        this.propertiesToCheck.forEach(key => {
          if (!this.vnData[key] || this.vnData[key] === 0) {
            this.isValid = false
            this.msg = 'Thiếu thông tin vn cần thiết'
          } else if (!this.enData[key] || this.enData[key] === 0) {
            this.isValid = false
            this.msg = 'Thiếu thông tin en cần thiết'
          }
        })
      }
    },
    async getNewsData () {
      this.isLoading = true
      // await this.$store.dispatch('news/getRegularNewsData')
      this.totalPages = await this.$store.dispatch('news/getRegularNewsByPageWithFilter', { filteredTerm: this.appliedTerm, pageNumber: this.currentPage })
      if (this.$store.getters['news/getBackendNewsData'].length === 0) {
        if (this.currentPage > 1) {
          this.currentPage--
          this.totalPages = await this.$store.dispatch('news/getRegularNewsByPageWithFilter', { filteredTerm: this.appliedTerm, pageNumber: this.currentPage })
        }
        if (this.totalPages < 1) this.totalPages = 1
      }
      this.isLoading = false
    },
    addClick () {
      this.vnData = {}
      this.enData = {
        title: '',
        summary: '',
        description: 'Nhập chi tiết ...'
      }
      this.hasCreatedData = true
      this.changeLang = false
      this.checkEn = false
      this.fileUpload = ''
      this.isValid = true
      this.isUpdated = false
      this.$refs.fileInput.value = null
      this.modalTitle = 'Thêm tin tức'
      this.id = 0
      this.img = ''
      this.title = ''
      this.summary = ''
      this.description = 'Nhập chi tiết ...'
      this.url = ''
      this.date = this.getCurrentDate()
      this.hidden = true
      this.menuId = 2
      this.lang = 'vn'
      this.tempImage = ''
      this.toggleModal()
    },
    async createClick () {
      this.requestLoading = true
      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError(this.msg)
        return
      }

      if (this.hasCreatedData) {
        if (!this.fileUpload) {
          this.$showError('Xin hãy chọn lại file ảnh')
          this.requestLoading = false
          return
        }
        await this.imageUploads()
        if (this.img === null) {
          this.requestLoading = false
          this.$showError('Lỗi upload hình ảnh')
          return
        }
      }

      if (this.url === '') {
        this.url = this.generateUrl(this.vnData.title)
      }

      const newNews = {
        img: this.img,
        url: this.url,
        hidden: this.hidden,
        date: this.date === '' ? null : this.date,
        category: 'regular'
      }

      try {
        if (this.hasCreatedData) {
          const vnNewsData = {
            ...this.vnData,
            ...newNews,
            lang: 'vn'
          }

          const enNewsData = {
            ...this.enData,
            ...newNews,
            lang: 'en'
          }

          await this.$store.dispatch('news/postNews', vnNewsData)
          await this.$store.dispatch('news/postNews', enNewsData)
        } else {
          const enMissingData = {
            ...this.enData,
            ...newNews,
            lang: 'en',
            url: this.originalUrl
          }

          await this.$store.dispatch('news/postNews', enMissingData)
        }

        this.requestLoading = false
        this.$showSuccess('Tạo thành công')
        await this.$store.dispatch('media/getMediaData')
        // reload hình ở đây để tránh lỗi (Khi vừa create xong mà update ảnh thì chưa cập nhật Id nên sẽ tự tạo mới ảnh)
        this.getNewsData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        this.$showError(error)
      }
    },
    getImageId (path) {
      return this.$store.getters['media/getMediaId'](path)
    },
    async adjustStatus (id) {
      await this.$store.dispatch('news/changeStatusNews', id)
      this.getNewsData()
    },
    editClick (data) {
      this.smallLoading = false
      this.hasCreatedData = false
      this.changeLang = true
      this.checkEn = false
      this.loadEditData = false
      this.originalUrl = data.url
      this.isValid = true
      this.isUpdated = true
      this.isPreview = false
      this.$refs.fileInput.value = null
      this.fileUpload = ''
      this.toggleModal()
      this.modalTitle = 'Chỉnh sửa tin tức'
      this.id = data.id
      this.img = data.img
      this.title = data.title
      this.summary = data.summary
      this.description = this.$sanitize(data.description)
      this.url = data.url
      this.hidden = data.hidden
      this.menuId = data.menuId
      this.lang = data.lang
      this.createdAt = data.createdAt
      this.updatedAt = data.updatedAt
      this.tempImage = data.img
      this.date = data.formattedDate
    },
    async updateClick () {
      this.requestLoading = true
      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError(this.msg)
        return
      }

      if (this.enData.id === 0) {
        this.requestLoading = false
        this.$showError('Có một dữ liệu en bị thiếu cần được tạo')
        return
      }

      if (this.fileUpload) {
        await this.imageUploads()
        if (this.img === null) {
          this.requestLoading = false
          this.$showError('Lỗi update hình ảnh')
          return
        }
      }

      const updatedNews = {
        img: this.tempImage,
        url: this.url,
        date: this.date === '' ? null : this.date,
        hidden: this.hidden,
        category: 'regular'
      }

      try {
        const vnNewsData = {
          ...this.vnData,
          ...updatedNews,
          lang: 'vn'
        }

        const enNewsData = {
          ...this.enData,
          ...updatedNews,
          lang: 'en'
        }

        await this.$store.dispatch('news/updateNews', vnNewsData)
        await this.$store.dispatch('news/updateNews', enNewsData)

        this.requestLoading = false
        this.$showSuccess('Cập nhật thành công')
        this.cacheBuster = Date.now()
        this.getNewsData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        this.$showError(error)
      }
    },
    async imageUploads () {
      const formData = new FormData()
      formData.append('file', this.fileUpload)
      formData.append('categoryId', 1)
      formData.append('lang', this.lang)

      const id = this.getImageId(this.tempImage)

      // post / update
      if (this.isUpdated === false || id === 0) {
        formData.append('fileName', this.fileUpload.name.split('.').slice(0, -1).join('.'))
        formData.append('createdAt', this.getCurrentDate())
        const patch = await this.$store.dispatch('media/postForDetail', formData)
        this.img = patch
      } else {
        formData.append('createdAt', this.createdAt)
        formData.append('updatedAt', this.getCurrentDate())
        formData.append('id', id)
        const patch = await this.$store.dispatch('media/updateForDetail', formData)
        this.img = patch
      }
    },
    async deleteClick (id) {
      this.requestLoading = true
      await this.$store.dispatch('news/deleteNews', id)
      this.requestLoading = false
      this.toggleAlert()
      this.getNewsData()
    }
  },
  created () {
    this.getNewsData()
  }
}
</script>

<style scoped>
  .table {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    outline: none;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border: 1px solid #0298cf;
    color: #0298cf;
  }

  .table-header select {
    padding: 10px 20px;
    margin: 0 10px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  /* Sua */
  td img {
    max-height: 60px;
    max-width: 60px;
    height: 60px;
    width: 60px;
    object-fit: cover;
    border-radius: 15px;
    border: 3px solid #ced0d2;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  .action-holder button{
    margin: 0 5px;
    width: 35px;
  }

  tr:nth-child(even) {background-color: #ececec }

  td:nth-child(1) {
    min-width: 220px;
  }

  td:nth-child(2) {
    width: 100px;
  }

  /* th:nth-child(7), td:nth-child(7) {
    text-align: center;
    width: 120px;
  } */

  th:nth-child(6), td:nth-child(6),th:nth-child(5), td:nth-child(5) {
    text-align: center;
    width: 100px;
  }

  th:nth-child(7), td:nth-child(7) {
    text-align: center;
    width: 80px;
    padding: 10px 7px;
  }

  .overflow-td {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  /* table end */
  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */

  .data-display {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 10px;/* Sua */
    /* border: 2px solid #000; */
  }

  .data-display .box {
    width: 120px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  #items {
    justify-content: space-between;
  }

  .data-display-s {
    display: flex;
    align-items: center;
  }

  .data-display-s select{
    margin-left: 10px;
  }

  .data-display-s #first {
    margin-left: 27px;
  }

  .outsite > .data-display {
    display: block;
  }

  .outsite textarea {
    margin-top: 5px;
    height: 55px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 5px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }

  .site-box {
    display: flex;
  }

  .first-site {
    flex: 1;
  }

  .second-site {
    width: 270px;
    padding-left: 45px;
  }

  .errors {
    font-weight: bold;
    color: red;
  }

  .ql-editor{
    height: 100%;
  }

  .detail {
    margin-bottom: 40px;
  }

  .detail .title {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 10px;
  }

  .date-container {
    display: flex;
  }

  #icon {
    width: 16px;
    height: 16px;
  }

  .img-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .detail .date {
    color: #ababab;
    font-size: 14px;
    margin-left: 5px;
  }

  .detail .content {
    margin-top: 40px;
  }

  .publish-text {
    color: rgb(65, 225, 65);
    font-weight: 700;
  }

  .draft-text {
    color: rgb(226, 191, 49);
    font-weight: 700;
  }

  #date-input {
    border: none;
    outline: none;
    background: transparent;
    position: absolute;
    top: 5px;
    left: 110px;
    font-size: 17px;
    background-color: white;
    width: 120px;
    height: 32px;
    padding: 0px;
  }

  #date-input::placeholder {
    color: initial;
  }
</style>
